module.exports = __webpack_public_path__ + "img/stop-fill.8a252492.svg";